module.exports = __webpack_public_path__ + "img/benefit-2-job.2f4b92f2.png";